import React, { useState, useRef, useEffect } from 'react';
import Logo from "../image/StayCool.png";
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import InputText from '../ReusableComponents/InputText';
import SliderSection from './SliderComponent';
import { FaLinkedin, FaFacebook, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Hotelcard from './Hotelcard';
import LoadingScreen from './LoadingScreen';
import MainPopup from '../popup-containers/MainPopup';
import PopUpScreenTitle from '../components/PopUpScreenTitle';
import Registerpopup from './Registerpopup';
import PopUpButtons from '../components/PopUpButtons';
import { useNavigate } from "react-router-dom";
import { Contact } from 'lucide-react';
import '../index.css';
import Amenitiespopup from './Amenitiespopup';
import PopupComponent from './PopupComponent';
import Roompopup from './Roompopup';
import Pricingpopup from './Pricingpopup';
import Callandbookpopup from './Callandbookpopup';
import Dashboardpopup from './Dashboardpopup';
import UserandRole from './UserandRole';
import Termspopup from './Termspopup';
import Privacypopup from './Privacypopup';
import Disclaimerpopup from './Disclaimerpopup';
import { BindAPI } from '../services/APIConnection';
const sliderImages = [
  {
    src: require('../image/Slider1.png'),
    heading: 'Stay Cool Resorts',
    subheading: 'Welcome To',
  },
  {
    src: require('../image/Slider 3.png'),
    heading: 'Luxury in Nature',
    subheading: 'Discover Tranquility',
  },
  {
    src: require('../image/Slider1.png'),
    heading: 'Unwind & Relax',
    subheading: 'Your Perfect Getaway',
  },
];

const HeaderSection = ({ searchData, setSearchData })  => {

  const { searchParams, hotelList } = searchData;
  const [current, setCurrent] = useState(0);
  const [destination, setDestination] = useState('');
  const [checkIn, setCheckIn] = useState('');
  const [checkOut, setCheckOut] = useState('');
  const [guests, setGuests] = useState(1);
  const [rooms, setRooms] = useState(1);
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userProfilePopUp, setUserProfilePopUp] = useState(false);
  const [errors, setErrors] = useState({});
  const childRef = useRef(null);
  const dropdownRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [homeDropdownOpen, setHomeDropdownOpen] = useState(false);
  const homeDropdownTimeoutRef = useRef(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [validationPopup, setValidationPopup] = useState({
    show: false,
    message: ""
  });

  const [showSection, setShowSection] = useState(true); 
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSupplierRegistration = () => {
    setUserProfilePopUp(true);
  };

  const handleCloseUserProfilePopUp = () => {
    setUserProfilePopUp(false);
  };
  const timeoutRef = useRef(null);

 

  const handleClick = () => {
    childRef.current.childFunction(); // Calling child function
  };
  const handleCancelClick = () => {
    if (
      childRef.current &&
      typeof childRef.current.childCancelFunction === "function"
    ) {
      childRef.current.childCancelFunction(); // ✅ Safe call
    } else {
      console.error("childCancelFunction is not defined");
    } // Calling child function
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setDropdownOpen(false);
    }, 300);
  };


  const [popupContent, setPopupContent] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [privacyPopup, setprivacyPopup] = useState(false);
  const [hotelData, setHotelData] = useState([]);
   const [hotelData1, setHotelData1] = useState([]);
  const handleFeatureClick = (feature) => {
    if (feature.component) {
      setPopupContent(feature.component);
      setShowPopup(true);
    }
  };

  const [formFields, setFormFields] = useState({
    guest: "",
    destination: "",
    checkin: "",
    checkout: "",
    rooms: "",
    children: "",
    adults: "",
  });
 useEffect(() => {
    const fetchAllMasterData = async () => {
      
      try {
        // Fetch master data in one call
        const response = await BindAPI("ClientsAPI/BindHomeScreen");

        if (response?.data) {
          const { Table,Table1 } = response.data;
          setHotelData(Table);
           setHotelData1(Table1);
           console.log("Table",Table);
            console.log("Table1",Table1);
        }
      } catch (error) {
        console.error("Error fetching master data:", error);
      }
    };

    fetchAllMasterData();
  }, []);
  // const hotelData = [
  //   {
  //     id: 1,
  //     name: "Park Inn by Radisson New Delhi IP",
  //     location: "Delhi",
  //     rating: 8.3,
  //     reviewCount: 10358,
  //     tag: "Very good",
  //     price: 7280,
  //     image: require("../image/hotel-1.avif"),
  //     provider: "Radisson Hotels",
  //     perks: ["Free cancellation"],
  //     amenities: ["Pool", "Gym", "Room Service"],
  //     contactnumber: "9080678907",
  //     Description: "Discover comfort and convenience at Park Inn by Radisson New Delhi IP, ideally located in the heart of Delhi. This modern hotel offers spacious, well-appointed rooms, excellent service, and thoughtful amenities to make every stay memorable. Guests can unwind by the refreshing pool, stay active in the fully equipped gym, or indulge in delicious meals with convenient room service. Rated Very Good by thousands of satisfied guests, it's a perfect choice for both business and leisure travelers. Enjoy the added benefit of free cancellation and experience the trusted hospitality of Radisson Hotels."
  //   },
  //   {
  //     id: 2,
  //     name: "Holiday Inn Agra MG Road",
  //     location: "Agra",
  //     rating: 9.2,
  //     reviewCount: 11541,
  //     tag: "Excellent",
  //     price: 4901,
  //     image: require("../image/hotel-2.avif"),
  //     provider: "Holiday Inn",
  //     perks: ["Free cancellation", "Breakfast included"],
  //     amenities: ["Pool", "Gym", "Room Service"],
  //     contactnumber: "7080678907",
  //     Description: "Experience a memorable stay at Holiday Inn Agra MG Road, perfectly located near Agra's iconic attractions. This Excellent-rated hotel is known for its warm hospitality, modern rooms, and exceptional service. Guests can relax by the inviting pool, work out at the well-equipped gym, or enjoy delicious in-room dining. Wake up to a hearty breakfast included with your stay and benefit from free cancellation for worry-free travel. Whether you're visiting for business or leisure, Holiday Inn Agra MG Road is your ideal home away from home."
  //   },

  //   {
  //     id: 3,
  //     name: "The Leela Palace Bengaluru",
  //     location: "Bengaluru",
  //     rating: 9.5,
  //     reviewCount: 8750,
  //     tag: "Exceptional",
  //     price: 14250,
  //     image: require("../image/hotel-2.avif"),
  //     provider: "The Leela",
  //     perks: ["Free cancellation", "Breakfast included"],
  //     amenities: ["Spa", "Pool", "Gym", "Room Service"],
  //     contactnumber: "8080678907",
  //     Description: "Indulge in unmatched luxury at The Leela Palace Bengaluru, a landmark of opulence in the heart of the city. This exceptional hotel offers elegant rooms with exquisite decor, world-class dining, and a serene spa experience. Guests can unwind by the outdoor pool, rejuvenate at the spa, or stay active at the modern fitness center. Enjoy complimentary breakfast and flexible free cancellation for a stress-free stay. The Leela Palace is the perfect destination for discerning travelers seeking sophistication and comfort."
  //   },
  //   {
  //     id: 4,
  //     name: "Taj Exotica Resort & Spa Goa",
  //     location: "Goa",
  //     rating: 9.7,
  //     reviewCount: 13420,
  //     tag: "Superb",
  //     price: 18900,
  //     image: require("../image/hotel-2.avif"),
  //     provider: "Taj Hotels",
  //     perks: ["Free cancellation", "Breakfast included"],
  //     amenities: ["Beach Access", "Spa", "Pool", "Gym", "Room Service"],
  //     contactnumber: "9080678910",
  //     Description: "Escape to paradise at Taj Exotica Resort & Spa Goa, nestled along the pristine beaches of South Goa. This superb beachfront resort features luxurious villas, lush gardens, and stunning ocean views. Guests can relax by the infinity pool, rejuvenate with holistic spa treatments, and savor exquisite cuisine. With free breakfast and flexible cancellation options, your stay is guaranteed to be as carefree as the coastal breeze. Perfect for a romantic getaway or a family retreat, Taj Exotica promises an unforgettable Goan experience."
  //   }
  // ];

  const features = [
    {
      icon: "🏡", title: "Room type & Room Management", description: "Add and manage villas, room types, photos, and status easily.",
      component: <Roompopup />
    },
    {
      icon: "💰", title: "Smart Tariff & Pricing", description: "Flexible rates for weekdays, weekends, and special seasons.",
      component: <Pricingpopup />,
    },
    {
      icon: "🎁", title: "Amenities Management", description: "Add or update amenities to showcase your villa's best features.",
      component: <Amenitiespopup />,
    },
    {
      icon: "📞", title: "Direct Call & Book", description: "Guests can call to check availability and book instantly.",
      component: < Callandbookpopup />
    },
    {
      icon: "📊", title: "Dashboard & Reports", description: "Track bookings, revenue, and occupancy with real-time reports.",
      component: < Dashboardpopup />
    },
    {
      icon: "👥", title: "User & Role Management", description: "Manage admins, staff roles, and secure login credentials.",
      component: <UserandRole />
    }
  ];



  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % sliderImages.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
  };

  const handleBlur = (e) => { };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const clear = () => {
setSearchResults([]);
setLoading(false);
setShowSection(false);
setFormFields({
    guest: "",
    destination: "",
    checkin: "",
    checkout: "",
    rooms: "",
    children: "",
    adults: "",
  });
  }
//   const handleSearch = () => {
//   const errorMessage = validateForm();
//   if (errorMessage) {
//     setValidationPopup({
//       show: true,
//       message: errorMessage
//     });
//     return;
//   }

//   setLoading(true);
//   setTimeout(() => {
//     // Filter by destination safely
//     const filteredResults = hotelData.filter(hotel =>
//       hotel.City && hotel.City.toLowerCase().includes(formFields.destination.toLowerCase())
//     );

//     setSearchResults(filteredResults);
//     setLoading(false);
//   }, 1500);
// };
const handleSearch = () => {
  const errorMessage = validateForm();
  if (errorMessage) {
    setValidationPopup({
      show: true,
      message: errorMessage
    });
    return;
  }

  setLoading(true);

  setTimeout(() => {
    const selectedCheckIn = new Date(formFields.checkin);
    const selectedCheckOut = new Date(formFields.checkout);
    const destination = formFields.destination.toLowerCase();

    const filteredResults = hotelData.filter(hotel => {
      // 1️⃣ Destination filter
      const destinationMatch =
        hotel.City &&
        hotel.City.toLowerCase().includes(destination);

      if (!destinationMatch) return false;

      // 2️⃣ Get all enquiries for this hotel/client
      const enquiries = hotelData1.filter(
        e => e.MstClientId === hotel.MstClientId
      );

      if (enquiries.length === 0) return true; // no bookings → available

      // 3️⃣ Check availability against all enquiries
      const isAvailable = enquiries.every(enquiry => {
        // Exclude Booked & Check-In
        if ([4, 6].includes(enquiry.MstEnquiryStatusId)) {
          const bookingCheckIn = new Date(enquiry.BookingFrom);
          const bookingCheckOut = new Date(enquiry.BookingTo);

          // NO overlap condition
          return (
            selectedCheckOut <= bookingCheckIn ||
            selectedCheckIn >= bookingCheckOut
          );
        }
        return true; // cancelled, checked-out, enquiry → available
      });

      return isAvailable;
    });

    setSearchResults(filteredResults);
    setLoading(false);
  }, 1500);
};


  const validateForm = () => {
    const emptyFields = [];

    if (!formFields.destination) emptyFields.push("Destination");
    if (!formFields.checkin) emptyFields.push("Check-in date");
    if (!formFields.checkout) emptyFields.push("Check-out date");
    if (!formFields.guest) emptyFields.push("Number of guests");
    if (!formFields.rooms) emptyFields.push("Number of rooms");
    if (!formFields.adults) emptyFields.push("Number of adults");
    if (!formFields.children) emptyFields.push("Number  of Children");

    if (emptyFields.length > 0) {
      return `Please fill the following fields: ${emptyFields.join(", ")}`;
    }

    if (formFields.checkin && formFields.checkout) {
      if (new Date(formFields.checkout) <= new Date(formFields.checkin)) {
        return "Check-out date must be after check-in date";
      }
    }
    const totalPeople = Number(formFields.adults) + Number(formFields.children);
    const totalGuests = Number(formFields.guest);

    if (totalPeople > totalGuests) {
      return "The total number of adults and children must not exceed the number of guests";
    }
    else
      if (totalPeople < totalGuests) {
        return "The total number of adults and children must not be less the number of guests"
      }

    return null;
  };
  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (

    <div className="w-full">
      {validationPopup.show && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold text-red-600"> Error</h3>
              <button
                onClick={() => setValidationPopup({ show: false, message: "" })}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
            <p className="mb-4">{validationPopup.message}</p>
            <div className="flex justify-end">
              <button
                onClick={() => setValidationPopup({ show: false, message: "" })}
                className="px-4 py-2 bg-[#3D6643] text-white rounded hover:bg-red-700"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
  <nav className="sticky top-0 z-50 bg-white shadow-sm px-6 py-4">
  <div className="flex items-center justify-between w-full max-w-7xl mx-auto">
    {/* Logo */}
    <div className="flex-none">
      <img src={Logo} alt="Stay Cool" className="h-10" />
    </div>

    {/* Hamburger Icon (Mobile Only) */}
    <div className="lg:hidden">
      <button
        onClick={() => setMenuOpen(!menuOpen)}
        className="text-[#3D6643] focus:outline-none"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          {menuOpen ? (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          ) : (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          )}
        </svg>
      </button>
    </div>

    {/* Desktop Navigation Links */}
    <div className="hidden lg:flex flex-grow justify-center">
      <div className="flex gap-8 text-sm md:text-base font-medium text-[#3D6643] whitespace-nowrap">
        <a href="#aboutus" className="hover:text-[#0B2E1B] transition-colors duration-300">About Us</a>
        <a href="#howstaycoolworks" className="hover:text-[#0B2E1B] transition-colors duration-300">Methodology</a>
        <a href="#keyfeatures" className="hover:text-[#0B2E1B] transition-colors duration-300">Key Features</a>
        <a href="#contactus" className="hover:text-[#0B2E1B] transition-colors duration-300">Contact Us</a>
      </div>
    </div>

    {/* Desktop Buttons */}
    <div className="hidden lg:flex items-center gap-4">
      <button
        onClick={(e) => {
          e.preventDefault();
          handleSupplierRegistration();
        }}
        className="bg-[#476540] hover:bg-[#2e4e33] text-white text-base font-semibold py-2 px-4 w-32 h-12 rounded-lg"
      >
        Registration
      </button>

      <button
        onClick={() => navigate("/login")}
        className="bg-[#476540] hover:bg-[#2e4e33] text-white text-base font-semibold py-2 px-4 w-24 h-12 rounded-lg"
      >
        Log In
      </button>
    </div>
  </div>

  {/* Mobile Dropdown Menu */}
  {menuOpen && (
    <div className="lg:hidden mt-4 space-y-4 text-center text-[#3D6643] font-medium">
      <a href="#aboutus" onClick={() => setMenuOpen(false)} className="block hover:text-[#0B2E1B]">About Us</a>
      <a href="#howstaycoolworks" onClick={() => setMenuOpen(false)} className="block hover:text-[#0B2E1B]">Methodology</a>
      <a href="#keyfeatures" onClick={() => setMenuOpen(false)} className="block hover:text-[#0B2E1B]">Key Features</a>
      <a href="#contactus" onClick={() => setMenuOpen(false)} className="block hover:text-[#0B2E1B]">Contact Us</a>

      <div className="pt-2 space-y-2">
        <button
          onClick={(e) => {
            e.preventDefault();
            handleSupplierRegistration();
            setMenuOpen(false);
          }}
          className="w-full bg-[#476540] hover:bg-[#2e4e33] text-white py-2 rounded-lg"
        >
          Registration
        </button>

        <button
          onClick={() => {
            navigate("/login");
            setMenuOpen(false);
          }}
          className="w-full bg-[#476540] hover:bg-[#2e4e33] text-white py-2 rounded-lg"
        >
          Log In
        </button>
      </div>
    </div>
  )}
</nav>




      <MainPopup
        popUpOpen={userProfilePopUp}
        setpopUpOpen={setUserProfilePopUp}
        loginPopups={true}
      >
        <div>
          <PopUpScreenTitle
            title=" Registration"
            setpopUpOpen={() => setUserProfilePopUp(!userProfilePopUp)}
            hederDetails={() => setUserProfilePopUp(!userProfilePopUp)}
          />
          <Registerpopup
            ref={childRef}
            closePopup={() => setUserProfilePopUp(!userProfilePopUp)}
          />
        </div>
        <PopUpButtons
          submitDetails={handleClick}
          handleSubmit={handleClick}
          cancel={handleCancelClick}
          disabledBtn={false}
        />
      </MainPopup>

      {/* Slider */}
      <div className='' data-aos="flip-left">
        <SliderSection sliderImages={sliderImages} height="90vh" autoSlide={true} />
      </div>

      {/* Search Bar */}
      {showSection && (
  <section className='' data-aos="fade-up">
    <div className="w-full max-w-8xl mx-auto p-4">
      <div className="relative bg-white shadow-lg rounded-lg p-4 flex flex-col lg:flex-row items-center gap-4">
        
        {/* Close Icon */}
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl font-bold"
          onClick={clear}
        >
          &times;
        </button>

        {/* Destination */}
        <div className="w-full lg:w-1/4">
          <InputText
            inputType="text"
            title="Destination"
            name="destination"
            maxLength={50}
            classStar="text-red-500"
            content={formFields.destination}
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            disabled={false}
          />
          {errors.destination && <p className="text-red-500 text-sm">{errors.destination}</p>}
        </div>

        {/* Check In */}
        <div className="w-full lg:w-1/4">
          <InputText
            inputType="date"
            title="Check in"
            name="checkin"
            maxLength={50}
            classStar="text-red-500"
            content={formFields.checkin}
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            disabled={false}
          />
          {errors.checkin && <p className="text-red-500 text-sm">{errors.checkin}</p>}
        </div>

        {/* Check Out */}
        <div className="w-full lg:w-1/4">
          <InputText
            inputType="date"
            title="Check Out"
            name="checkout"
            maxLength={50}
            classStar="text-red-500"
            content={formFields.checkout}
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            disabled={false}
          />
          {errors.checkout && <p className="text-red-500 text-sm">{errors.checkout}</p>}
        </div>

        {/* Guests & Rooms */}
        <div className="w-full lg:w-1/4">
          <div className="flex flex-col sm:flex-row gap-2">
            <InputText
              inputType="text"
              title="Guest"
              name="guest"
              classStar="text-red-500"
              controlFunc={handleInputChange}
              controlFuncBlur={handleBlur}
              content={formFields.guest || ""}
              disabled={false}
              Class="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            />
            {errors.guest && <p className="text-red-500 text-sm">{errors.guest}</p>}

            <InputText
              inputType="text"
              title="Rooms"
              name="rooms"
              classStar="text-red-500"
              controlFunc={handleInputChange}
              controlFuncBlur={handleBlur}
              content={formFields.rooms}
              disabled={false}
              Class="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            />
            {errors.rooms && <p className="text-red-500 text-sm">{errors.rooms}</p>}

            <InputText
              inputType="text"
              title="Adults"
              name="adults"
              classStar="text-red-500"
              controlFunc={handleInputChange}
              controlFuncBlur={handleBlur}
              content={formFields.adults}
              disabled={false}
              Class="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            />
            {errors.adults && <p className="text-red-500 text-sm">{errors.adults}</p>}

            <InputText
              inputType="text"
              title="Children"
              name="children"
              classStar="text-red-500"
              controlFunc={handleInputChange}
              controlFuncBlur={handleBlur}
              content={formFields.children}
              disabled={false}
              min="0"
              max="20"
              Class="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            />
            {errors.children && <p className="text-red-500 text-sm">{errors.children}</p>}
          </div>
        </div>

        {/* Search Button */}
        <div className="w-full lg:w-auto">
          <button
            onClick={handleSearch}
            disabled={loading}
            className={`w-full lg:w-auto mt-2 px-6 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition duration-300
              ${loading ? "bg-[#476540] cursor-not-allowed" : "bg-[#476540] hover:bg-[#476540] text-white"}
            `}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <svg
                  className="animate-spin h-5 w-5 mr-2 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8H4z"
                  ></path>
                </svg>
                Searching...
              </div>
            ) : (
              "Search"
            )}
          </button>
        </div>

      </div>
    </div>
  </section>
)}


{!showSection && (
  <button
    onClick={() => setShowSection(true)}
    className="bg-[#476540] text-white px-4 py-2 rounded-lg mt-4 mx-auto block"
  >
    Show Search Bar
  </button>
)}

      {searchResults.length > 0 && (
        <div className="p-4 max-w-7xl mx-auto">
          <h2 className="text-2xl font-bold mb-4">Available Hotels</h2>
          {searchResults.map(hotel => (
            <Hotelcard key={hotel.id} hotel={hotel} />
          ))}
        </div>
      )}

      <section id="aboutus" className="bg-white scroll-mt-20 px-6 py-6  text-[#2E4E33] " data-aos="fade-up">
        <div className="max-w-7xl p-4 mx-auto">
          <h2 className="text-3xl font-semibold text-center mb-4">About Us</h2>
          <p className="mb-4 text-xl">
            Welcome to <span className="font-semibold">Stay Cool</span>, your trusted partner in seamless villa booking experiences.
          </p>
          <p className="mb-4 text-xl md:text-justify">
            At Stay Cool, we specialize in delivering smart, intuitive, and elegant booking software designed specifically for villa owners, resort managers, and luxury property hosts. Born out of a passion for hospitality and innovation, our platform simplifies the way you manage your reservations, calendar, availability, and guest interactions — all in one place.
          </p>
          <ul className="list-disc list-inside mb-4 text-xl md:text-justify space-y-1">
            <li>Automate bookings and avoid double reservations</li>
            <li>Showcase your villas with high-quality galleries</li>
            <li>Communicate with guests effortlessly</li>
          </ul>
          <p className="mb-4 md:text-justify text-xl">
            Whether you're managing a single beachside retreat or a portfolio of premium getaways, Stay Cool is your ultimate tool to stay organized, stay efficient, and stay cool.
          </p>
          <p className='text-xl md:text-justify'>
            Join hundreds of villa owners who trust Stay Cool to keep their properties booked and their guests happy.
          </p>
        </div>
      </section>

      <section id="howstaycoolworks" className="bg-[#476540] scroll-mt-[72px] px-6 py-6 text-white " data-aos="fade-up">
        <div className="max-w-7xl p-4 mx-auto">
          <h2 className="text-3xl font-semibold text-center mb-6">Methodology</h2>

          <p className="text-xl leading-relaxed  md:text-justify mb-4 text-center">
            At <strong>Stay Cool</strong>, we make villa booking simple and seamless for both guests and property owners.
          </p>

          {/* Guests */}
          <div className="mt-4">
            <h3 className="text-2xl font-semibold mb-2">For Guests</h3>
            <p className="text-xl  md:text-justify leading-relaxed mb-2">
              Guests can directly call the villa to make enquiries or confirm bookings. Our friendly team assists with
              availability, pricing, and reservation details to ensure a smooth experience.
            </p>
          </div>

          {/* Villa Owners */}
          <div className="mt-8">
            <h3 className="text-2xl font-semibold mb-2">For Villa Owners (Clients)</h3>
            <p className="text-xl  md:text-justify leading-relaxed mb-2">
              Property owners must register on our platform. Once approved, they receive login credentials to access the
              Stay Cool software. From there, they can manage bookings, check availability, and respond to enquiries—all in
              one easy-to-use dashboard.
            </p>
            <ul className="list-disc list-inside pl-2 text-lg space-y-1">
              <li>Automate your booking process and prevent double bookings</li>
              <li>Manage guest details, check-ins, and cancellations effortlessly</li>
            </ul>
          </div>

          {/* Call to Action */}
          <div className="mt-10 text-center">
            <p className="text-xl font-semibold md:text-justify mb-2">Join hundreds of villa owners and guests already enjoying Stay Cool.</p>
            <button className=" bg-white text-[#476540] font-bold py-2 mt-6 px-6 rounded shadow hover:bg-gray-100 transition duration-300" onClick={(e) => {
              e.preventDefault();
              handleSupplierRegistration();
            }}>
              Register Today
            </button>
          </div>
        </div>
      </section>

      <section
  id="keyfeatures"
  className="bg-white scroll-mt-24 px-6 py-12 text-[#476540]"
  data-aos="fade-up"
>
  <h2 className="text-3xl md:text-4xl font-semibold text-center mb-10">
    Key Features
  </h2>

  <div className="grid gap-8 max-w-7xl mx-auto grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
    {features.map((feature, index) => (
      <div
        key={index}
        className="flex items-start space-x-4 border p-4 rounded-lg shadow-sm hover:shadow-md transition"
        onClick={() => handleFeatureClick(feature)}
      >
        <div className="text-4xl text-[#3D6643]">{feature.icon}</div>
        <div>
          <h3 className="text-xl hover:cursor-pointer font-semibold text-[#3D6643] mb-1">
            {feature.title}
          </h3>
          <p className="text-sm text-gray-700">{feature.description}</p>
        </div>
      </div>
    ))}
  </div>
</section>


      {/* <section
        id="meetourclients"
        className="bg-[#476540] scroll-mt-24 px-6 py-12 text-black"
        data-aos="fade-up"
      >
        <h2 className="text-3xl text-white md:text-4xl font-semibold text-center mb-10">
       Meet Our Clients
        </h2>
        <div className="max-w-7xl mx-auto p-4">
          <p className="text-white text-justify text-xl mb-6">
            StayCool proudly partners with a growing network of villa owners, resort managers, and vacation rental hosts who rely on our platform to simplify their property management. From cozy hill station cottages to luxurious beachside villas, our clients span every corner of the country.
          </p>
          <div class="grid gap-6 md:grid-cols-2">
            <div class="bg-white p-6 shadow rounded">
              <p class="italic text-gray-700">“StayCool makes everything easier. I can check availability, respond to enquiries, and manage my rooms in one place. It's a must-have for villa owners.”</p>
              <h4 class="font-bold mt-4 text-green-700">– Arvind P., Whispering Woods</h4>
            </div>
            <div class="bg-white p-6 shadow rounded">
              <p class="italic text-gray-700">“From seasonal pricing to guest check-ins, StayCool handles it all smoothly. I’m spending less time on admin and more time improving guest experiences.”</p>
              <h4 class="font-bold mt-4 text-green-700">– Divya M., Coral Bay Villas</h4>
            </div>

            <div class="bg-white p-6 shadow rounded transition-transform duration-300 transform hover:scale-105">
              <p class="italic text-gray-700">"StayCool takes care of everything – pricing, bookings, check-ins – without me lifting a finger. Now I focus on making my guests feel special, not buried in paperwork."</p>
              <h4 class="font-bold mt-4 text-green-700">– Rohit K., Ocean Nest Retreat</h4>
            </div>
            <div class="bg-white p-6 shadow rounded transition-transform duration-300 transform hover:scale-105">
              <p class="italic text-gray-700">"StayCool takes care of everything – pricing, bookings, check-ins – without me lifting a finger. Now I focus on making my guests feel special, not buried in paperwork."</p>
              <h4 class="font-bold mt-4 text-green-700">– Anita S., Blue Horizon Homestay</h4>
            </div>
          </div>
        </div>
      </section>
 */}

      <PopupComponent
        show={showPopup}
        onClose={() => setShowPopup(false)}
        title="Feature Details"
      >
        {popupContent}
      </PopupComponent>

      <section id="contactus" className='bg-[#2E4E33] text-white px-6 py-6 text-black ' data-aos="fade-up">
        {/* <h2 className="text-3xl font-semibold text-center mb-4">Contact Us</h2> */}

        <div className="gird grid-cols-1 md:grid grid-cols-3 p-4">
          {/* <div className="p-4">
            <img src={Logo} alt="StayCool Logo" className="h-24 mb-4" />
            <p className="text-lg leading-relaxed">
              <strong>StayCool</strong> is your trusted partner in modern villa booking solutions.
              With seamless tools for hosts and a clean booking experience for guests, we help you
              stay organized, stay efficient — and stay cool.
            </p>
          </div> */}

          <div className="p-4">
            <h3 className="font-semibold mb-2 text-2xl">Contact us</h3>
            <p>
              <p>No 7, Kasthuri Bai Street,</p>
              <p>Kausalya Nagar, </p>
              <p> Chitlapakkam, </p>
              <p> Chennai-600064 </p>
              <p> Phone: +91 44 4777 6823 </p>
              <p> Mobile no:8754595873 </p>
              <p> Email:
              admin@stay-cool.in </p>
            </p>
            <div className="flex space-x-4 text-xl text-whitte">
              <a href="#"><FaLinkedin /></a>
              <a href="#"><FaFacebook /></a>
              <a href="#"><FaTwitter /></a>
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaYoutube /></a>
            </div>
          </div>

          <div className="p-4">
            <h3 className="font-semibold mb-2 text-2xl">Policies</h3>
            <ul className="space-y-2  text-white ">
              <li>
                <button
                  className="text-white  hover:underline cursor-pointer"
                  onClick={() => {
                    setPopupContent(<Termspopup />);
                    setShowPopup(true);
                  }}
                >
                  Terms of Service
                </button>
              </li>
              <li>
                <button
                  className=" text-white  hover:underline cursor-pointer"
                  onClick={ () =>{
                    setPopupContent(<Privacypopup />);
                    setShowPopup(true);
                  }}
                  
                >
                  Privacy policy
                </button>
              </li>
              <li>
                <button
                  className=" text-white  hover:underline cursor-pointer"
                  onClick={ () =>{
                    setPopupContent(<Disclaimerpopup />);
                    setShowPopup(true);
                  }}
                  
                >
                  Disclaimer
                </button>
              </li>
            </ul>
          </div>

          <div className='p-4'>
            <h3 className="font-semibold mb-2 text-2xl">Site Map</h3>
            <ul className="space-y-1 text-white ">
              <li><a href="#aboutus" className="hover:underline">About Us</a></li>
              <li><a href="#howstaycoolworks" className="hover:underline">Methodology</a></li>
              <li><a href="#keyfeatures" className="hover:underline">Key Features </a></li>
              {/* <li><a href="#meetourclients" className="hover:underline">Meet Our Clients </a></li> */}

              <li><a href="#contactus" className="hover:underline">Contact Us</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HeaderSection;